import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10a6 6 0 1 1 12 0v10","key":"svg-0"}],["path",{"d":"M12 16h8","key":"svg-1"}],["path",{"d":"M12 12h8","key":"svg-2"}]]

/**
 * IconCurrencyDram
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktZHJhbSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCAxMGE2IDYgMCAxIDEgMTIgMHYxMCIgLz4KICA8cGF0aCBkPSJNMTIgMTZoOCIgLz4KICA8cGF0aCBkPSJNMTIgMTJoOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/currency-dram
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyDram = createReactComponent('outline', 'currency-dram', 'CurrencyDram', __iconNode);

export default IconCurrencyDram;